export const REGION_NAMES = {
    region1: "Eastern Continent - Midgar Metropolis",
    region2: "Eastern Continent - Junon Municipality",
    region3: "Western Continent - Eastern Seaboard",
    region4: "Western Continent - Central Range",
    region5: "Mideel Forest",
    region6: "Northern Continent",
    region7: "Stable Born"
  }
  
  export const getRegionDisplayName = (regionId) => {
    return REGION_NAMES[regionId] || regionId
  }
  export const CATCH_REGION_NAMES = {
    region1: "Eastern Continent - Midgar Metropolis",
    region2: "Eastern Continent - Junon Municipality",
    region3: "Western Continent - Eastern Seaboard",
    region4: "Western Continent - Central Range",
    region5: "Mideel Forest",
    region6: "Northern Continent"
  }
  
  export const getCatchRegionDisplayName = (regionId) => {
    return CATCH_REGION_NAMES[regionId] || regionId
  }